"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.stripe.info': 'Please complete the payment using the Stripe Elements below.',
    'payment.stripe.clientSecret': 'Client Secret',
    'payment.stripe.noClientSecret': 'No Stripe client secret available',
};
